import { h } from 'preact';
import SharedLocationHeader from '../../features/customer-experience/header/shared-location-header';
import { Layout, LayoutHeader, LayoutContent } from '@bringg/react-components';
import NotFoundMessage from '../../components/not-found-message/not-found-message';
import PoweredByFooter from '../../components/powered-by-footer/powered-by-footer';

const NotFoundPage = () => {
	return (
		<Layout className="customer-experience">
			<LayoutHeader className="customer-experience-header-layout">
				<SharedLocationHeader />
			</LayoutHeader>
			<LayoutContent className="customer-experience-content-layout">
				<div className="not-found-page-container">
					<NotFoundMessage />
				</div>
			</LayoutContent>
			<PoweredByFooter />
		</Layout>
	);
};

export default NotFoundPage;
